import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor($state,SaaspassConnectService,Alert) {
        this.SaaspassConnectService = SaaspassConnectService;
        this.Alert = Alert;
        this.$state = $state;
    }

    $onInit() {
        this.connectApplication={};
        this.connectApplication.id=null;       
        this.connectApplication.oauthClientDetails={};
        this.connectApplication.oauthClientDetails.callUrl=null;
        this.connectApplication.ipAddressFilter=null;
        this.connectApplication.userProfileScopeRequested=false;
        this.connectApplication.userEmailScopeRequested=true;
        this.connectApplication.userPhoneScopeRequested=false;
        this.connectApplication.userAddressScopeRequested=false;   	
    }

    save() {   	
    	this.SaaspassConnectService.saaspassConnects
        .save({id:this.$state.params.companyId},this.connectApplication).$promise
        .then((data) =>  {
        	this.close();
        	this.$state.go('company.saaspass-connect.manage', {connectId: data.id}, {reload: 'company.saaspass-connect'});
            this.Alert('success', 'saaspass_connect.create_success');            
        })
        .catch((error) => this.spAlert = new SpAlert('danger', error.data.message));
    }
          
}



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/add-saaspass-connect/add-saaspass-connect.controller.js